import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import Link from "../../../../../elements/Link";
import Button, { ButtonKind } from "../../../../../elements/Button";

var PlanCardFooter = function PlanCardFooter(_ref) {
  var id = _ref.id,
      type = _ref.type,
      linkHref = _ref.linkHref,
      linkTitle = _ref.linkTitle,
      buttonHref = _ref.buttonHref,
      buttonText = _ref.buttonText,
      onclickBtn = _ref.onclickBtn;
  var getClassName = getClassNameFactory(PlanCardFooter.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName(),
    id: id
  }, linkTitle && /*#__PURE__*/React.createElement(Link, {
    type: type,
    id: "".concat(id, "-link"),
    href: linkHref
  }, linkTitle), buttonText && /*#__PURE__*/React.createElement(Button, {
    block: true,
    color: "primary",
    kind: ButtonKind.LINK,
    id: "".concat(id, "-button"),
    href: buttonHref,
    onClick: onclickBtn
  }, buttonText));
};

PlanCardFooter.displayName = "PlanCardFooter";
PlanCardFooter.propTypes = {
  id: PropTypes.string,

  /**
   * Type of link
   */
  type: PropTypes.oneOf(["primary", "action"]),

  /**
   * Href text
   */
  linkHref: PropTypes.string,

  /**
   * Link text
   */
  linkTitle: PropTypes.string,

  /**
   * Button href
   */
  buttonHref: PropTypes.string,

  /**
   * Button text
   */
  buttonText: PropTypes.string,
  onclickBtn: PropTypes.func
};
export default PlanCardFooter;